import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators as bind} from 'redux';
import * as submissionInfoActions from '../../actions/submissionInfoActions';
import { postNewSubmissionAttachments } from '../../actions/attachmentActions';
import fields from '../../constants/fieldsForNewSubmissionForm';
import Form from '../common/Form/Form';
import { totalSections, isFirstSection } from '../../lib/sectionUtils';
import StandardFormUploadInstructions from './StandardFormUploadInstructions';
import sharedProps from '../common/Form/SharedFormProps';
import { sharedDispatchToProps, sharedStateToProps } from '../common/Form/SharedReduxToProps';
import * as accountDetailsActions from '../../actions/accountDetailsActions';
import * as addressActions from '../../actions/addressActions';
import * as industriesApiUtils from '../../api/industriesApiUtils';

const progressText = {
  1: {
    line1: 'Business',
    line2: 'Details'
  },
  2: {
    line1: 'Application',
    line2: 'Information'
  },
  3: {
    line1: 'Financing',
    line2: 'Information'
  },
  4: {
    line1: 'Upload',
    line2: 'Documents'
  }
};

export class SubmissionForm extends Component {
  constructor() {
    super();

    this.state = {industries: []};

    this.totalSections = totalSections(progressText);
  }

  componentDidMount(){
    this.props.addOwner();
    industriesApiUtils.getIndustries()
    .then((industries) => this.setState(() => ({industries: industries})));
  }

  title() {
    if(isFirstSection(this.props)) {
      return 'Submissions Portal';
    } else {
      return this.props.submission.name;
    }
  }

  render() {
    const { submission, postNewSubmissionInfo } = this.props;
    return (
      <Form
        {...this.props}
        fields={fields(this.state.industries)}
        label="Lead Submission Form"
        postSubmission={() => postNewSubmissionInfo(submission)}
        progressText={progressText}
        title={this.title()}
        totalSections={this.totalSections}
        uploadInstructions={<StandardFormUploadInstructions/>}
      />
    );
  }
}

SubmissionForm.propTypes = {
  ...sharedProps,
  accountDetailsActions: PropTypes.object,
  addressActions: PropTypes.object,
  addOwner: PropTypes.func.isRequired,
  googleBusinessLookupUsed: PropTypes.bool.isRequired,
  postNewSubmissionInfo: PropTypes.func.isRequired,
  uuid: PropTypes.string
};

function mapStateToProps(state) {
  return {
    dba: state.submission.name,
    googleBusinessLookupUsed: !!state.submission.google_place_id,
    submissionForm: state.submissionForm,
    uuid: state.uuid,
    ...sharedStateToProps(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountDetailsActions: bind(accountDetailsActions, dispatch),
    addressActions: bind(addressActions, dispatch),
    addOwner: bind(submissionInfoActions.addOwner, dispatch),
    postNewSubmissionInfo: bind(
      submissionInfoActions.postNewSubmissionInfo,
      dispatch
    ),
    postSubmissionAttachments: bind(postNewSubmissionAttachments, dispatch),
    ...sharedDispatchToProps(dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmissionForm);
